import upLoading from './loading'
export default {
    install: (Vue) => {
        Vue.component('loading',upLoading)
    }
}